<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="阴保类型" prop="deviceTypeId" >
        <a-select v-model="form.deviceTypeId" placeholder="请选择阴保类型" allow-clear>
          <a-select-option v-for="item in deviceTypeList" :key="item.id" :value="item.id">
            {{item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="风险等级" prop="riskLevel" >
        <a-radio-group v-model="form.riskLevel">
          <a-radio :value="1">高</a-radio>
          <a-radio :value="2">中</a-radio>
          <a-radio :value="3">低</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="故障或风险描述" prop="faultOrRiskDescription" >
        <a-input type="textarea" v-model="form.faultOrRiskDescription" placeholder="请输入故障或风险描述"/>
      </a-form-model-item>
      <a-form-model-item label="诊断标准" prop="diagnosticCriteria" >
        <a-input type="textarea" v-model="form.diagnosticCriteria" placeholder="请输入诊断标准"/>
      </a-form-model-item>
      <a-form-model-item label="建议措施" prop="recommendedMeasure" >
        <a-input type="textarea" v-model="form.recommendedMeasure" placeholder="请输入建议措施" />
      </a-form-model-item>
      <a-form-model-item label="评价指标" prop="evaluatingIndicator">
        <a-input type="textarea" v-model="form.evaluatingIndicator" placeholder="请输入评价指标" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getKnowledge, addKnowledge, updateKnowledge, listDeviceType } from '@/api/saifuneng/knowledge'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      deviceTypeList: [],
      // 表单参数
      form: {
        id: null,
        deviceTypeId: null,
        riskLevel: null,
        faultOrRiskDescription: null,
        diagnosticCriteria: null,
        recommendedMeasure: null,
        evaluatingIndicator: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        deviceTypeId: [
          { required: true, message: '阴保类型不能为空', trigger: 'blur' }
        ],
        riskLevel: [
          { required: true, message: '风险等级不能为空', trigger: 'blur' }
        ],
        faultOrRiskDescription: [
          { required: true, message: '故障或风险描述不能为空', trigger: 'blur' }
        ],
        recommendedMeasure: [
          { required: true, message: '建议措施不能为空', trigger: 'blur' }
        ],
        diagnosticCriteria: [
          { required: true, message: '诊断标准不能为空', trigger: 'blur' }
        ],
        evaluatingIndicator: [
          { required: true, message: '评价指标不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getDeviceTypeList()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        deviceTypeId: null,
        riskLevel: null,
        faultOrRiskDescription: null,
        diagnosticCriteria: null,
        recommendedMeasure: null,
        evaluatingIndicator: null,
        remark: null
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getKnowledge({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateKnowledge(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addKnowledge(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    // 查询设备类型
    getDeviceTypeList() {
      listDeviceType().then(response => {
        this.deviceTypeList = response.data
      })
    }


  }
}
</script>
